export default __webpack_public_path__ + "static/media/room-e-F.e95a6f19.jpg";